//
export default [
    {
        name: "warehouse_roles",
        type: "select",
        props: {
            chips: true,
            items: [
                {
                    text: "Si",
                    value: 1,
                },
                {
                    text: "No",
                    value: 0,
                },
            ],
            label: "De bodega",
            noDataText: "Sin opciones.",
        },
        flex: {
            sm3: true,
        },
    }
]

// names, last_name1, last_name2, email, role, rut, search, is_ground_seller